import React from "react";
import { WizardMessagesList } from "../../components/profile/onboarding/WizardMessagesList";
import { WizardTypingIndicator } from "../../components/profile/onboarding/components/WizardTypingIndicator";
import { WizardInput } from "../../components/profile/onboarding/components/WizardInput";
import type { WizardMessage } from "../../components/profile/onboarding/types";
import type { WizardStepId } from "../../components/profile/onboarding/types";
import type { CadastroWizardReturn } from "./useCadastroWizard";

const currentStepWizard: WizardStepId = "welcome";

type Props = {
  wizard: CadastroWizardReturn;
};

export const CadastroWizardScreen: React.FC<Props> = ({ wizard }) => {
  const {
    messages,
    isBotTyping,
    messagesContainerRef,
    messagesEndRef,
    inputValue,
    processing,
    submitStep,
    handleInputChange,
    inputMeta,
    showTextInput,
  } = wizard;

  return (
    <>
      <WizardMessagesList
        messages={messages as WizardMessage[]}
        messagesContainerRef={messagesContainerRef}
        messagesEndRef={messagesEndRef}
        currentStep={currentStepWizard}
        onImageUpload={() => {}}
        profileData={null}
        guestAlignUserBubbles
      />
      {isBotTyping && <WizardTypingIndicator />}
      {showTextInput && (
        <div className="flex-shrink-0 border-t border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
          <div className="px-4 pt-3">
            <label
              htmlFor="cadastro-wizard-input"
              className="text-sm font-medium text-gray-800 dark:text-gray-200"
            >
              {inputMeta.label}
            </label>
          </div>
          <WizardInput
            labelId="cadastro-wizard-input"
            value={inputValue}
            onChange={handleInputChange}
            onSubmit={() => void submitStep()}
            isProcessing={processing}
            isBotTyping={isBotTyping}
            showTopBorder={false}
            inputType={inputMeta.inputType}
            autoComplete={inputMeta.autoComplete}
            inputMode={inputMeta.inputMode}
            placeholder={inputMeta.placeholder}
          />
        </div>
      )}
    </>
  );
};
